import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA service worker (Phase 1 — installability + offline shell)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Snapshot whether a service worker was ALREADY controlling this page load.
    // Only a truthy value here means the user had a previous version installed —
    // i.e. this is a genuine update, not someone's very first-ever visit.
    const hadController = !!navigator.serviceWorker.controller;

    navigator.serviceWorker.register('/service-worker.js')
      .then((reg) => {
        // Auto-update: when a new SW is found, activate it ASAP and reload once
        reg.addEventListener('updatefound', () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener('statechange', () => {
            if (sw.state === 'installed' && navigator.serviceWorker.controller) {
              sw.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
        // When the new SW takes control, reload to pick up new HTML — but ONLY
        // if this page was already controlled before (a real update). If there
        // was no previous controller, clients.claim() taking over a brand-new
        // visitor's tab is not an "update" and must NOT force a reload (this
        // was silently discarding in-progress form input on first-ever loads).
        let refreshed = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (refreshed || !hadController) return;
          refreshed = true;
          window.location.reload();
        });
      })
      .catch((err) => console.warn('SW registration failed:', err));
  });
}
